import { Delete } from '../helpers';
import { watermarkPath } from './path';

export default function DeleteWatermark({ channel, uuid }: { channel: number; uuid: string }) {
  return Delete<void>({
    path: watermarkPath(channel) + `/${uuid}`,
  });
}
